// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"7122891a","371":"98fa23f6","787":"aa872ce0"}[chunkId] + ".chunk.js";
};